<template>
  <div class="w-full border rounded-md w-full flex flex-col mb-4">
    <div
      class="w-full mx-0 my-4 px-10 py-4 grid grid-cols-9 w-full gap-1"
      :class="{
        'grid-cols-8': !enableEditNkrCode,
        'grid-cols-9': enableEditNkrCode
      }"
    >
      <div v-if="enableEditNkrCode">
        <template v-if="!editing">
          {{ originalProduct.nkrCode }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="text"
            placeholder="nkr code"
            v-model="editingProduct.nkrCode"
          />
        </template>
      </div>
      <div>
        <template v-if="!editing">
          {{ originalProduct.skuAlias }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="text"
            placeholder="sku-alias"
            v-model="editingProduct.skuAlias"
          />
        </template>
      </div>
      <div>
        {{ originalProduct.marketplaceName }}
        <template
          v-if="originalProduct.marketplaceName === 'amazon' && syncStatusLabel"
        >
          <br />
          <span
            class="inline-block px-2 py-0.5 mt-1 rounded text-xs text-white"
            :class="syncStatusClass"
            :title="originalProduct.lastError || ''"
          >
            {{ syncStatusLabel }}
          </span>
        </template>
      </div>
      <div>
        <template v-if="!editing">
          {{ originalProduct.marketplaceItemId }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="text"
            placeholder="marketplaceItemId"
            v-model="editingProduct.marketplaceItemId"
          />
        </template>
      </div>
      <!-- <div>
        <template v-if="!editing">
          {{ originalProduct.marketplaceShippingWeight }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="number"
            step="0.01"
            placeholder="shipping weight"
            @input="updateAdjustment"
            v-model="editingProduct.marketplaceShippingWeight"
          />
        </template>
        <template v-if="originalProduct.marketplaceName == 'amazon'">
          <br />
          (${{ priceAdjustmentShipment }} shipment)
        </template>
      </div> -->
      <div class="text-center">
        <template v-if="!editing">
          {{ originalProduct.priceAdjustmentPercentage }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="number"
            step="0.01"
            placeholder="priceAdjustmentPercentage"
            v-model="editingProduct.priceAdjustmentPercentage"
          />
        </template>
      </div>
      <div class="text-center">
        <template v-if="!editing">
          {{ originalProduct.priceAdjustmentFixed }}
        </template>
        <template v-else>
          <input
            class="regular bordered full"
            type="number"
            step="0.01"
            placeholder="priceAdjustmentFixed"
            v-model="editingProduct.priceAdjustmentFixed"
          />
        </template>
      </div>
      <div class="text-center">
        <template v-if="!editing">
          {{ originalProduct.enabledForExports == 1 ? "Yes" : "No" }}
        </template>
        <template v-else>
          <select
            class="regular bordered full"
            name="export-enabled"
            id="export-enabled"
            v-model="editingProduct.enabledForExports"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </template>
      </div>
      <div class="text-center">
        <template v-if="!editing">
          {{ originalProduct.fba == 1 ? "Yes" : "No" }}
        </template>
        <template v-else>
          <select
            name="fba"
            id="fba"
            class="regular bordered full"
            v-model="editingProduct.fba"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </template>
      </div>
      <div class="text-center">${{ item.calculatedPrice }}</div>
      <div class="flex flex-row justify-center">
        <template v-if="!editing">
          <div class="relative flex justify-center">
            <button
              class="w-10 h-10 border rounded-full bg-gray-200 flex justify-center items-center flex-shrink-0 hover:bg-gray-300"
              :title="$t('message.marketplaces.actions')"
              @click="toggleMenu()"
            >
              <BaseMiniSpinner v-if="syncing" />
              <span v-else class="text-xl leading-none font-bold">⋮</span>
            </button>
            <!-- backdrop para cerrar al hacer click fuera -->
            <div
              v-if="showMenu"
              class="fixed inset-0 z-10"
              @click="closeMenu()"
            ></div>
            <div
              v-if="showMenu"
              class="absolute right-0 top-11 z-20 w-56 bg-white border rounded-md shadow-lg py-1 text-left text-sm"
            >
              <a
                :href="urlMarketplace"
                target="_blank"
                class="block px-4 py-2 hover:bg-gray-100"
                @click="closeMenu()"
              >
                {{ $t("message.marketplaces.view_on_marketplace") }}
              </a>
              <template v-if="userCanEditMarketplacesItems">
                <button
                  class="w-full text-left px-4 py-2 hover:bg-gray-100"
                  @click="runMenuAction(initEdition)"
                >
                  {{ $t("message.marketplaces.edit") }}
                </button>
                <template v-if="originalProduct.marketplaceName === 'amazon'">
                  <button
                    class="w-full text-left px-4 py-2 hover:bg-gray-100 disabled:opacity-50"
                    :disabled="syncing"
                    @click="runMenuAction(syncAmazon)"
                  >
                    {{ $t("message.marketplaces.sync_to_amazon") }}
                  </button>
                </template>
                <div class="border-t my-1"></div>
                <button
                  class="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50"
                  @click="runMenuAction(deleteProduct)"
                >
                  {{ $t("message.marketplaces.delete") }}
                </button>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <button
            class="w-10 h-10 mx-2 border rounded-full p-2 bg-green-500 flex-shrink-0"
            @click="saveChanges()"
          >
            <img class="w-full" src="@/assets/icons/check.svg" />
          </button>
          <button
            class="w-10 h-10 mx-2 border rounded-full p-2 bg-red-500 flex justify-center items-center flex-shrink-0"
            @click="cancelEdition()"
          >
            <img class="w-full" src="@/assets/icons/x.svg" />
          </button>
        </template>
      </div>
    </div>
    <!-- <div class="ml-4 mb-4" v-if="editing && item.marketplaceName === 'amazon'">
      <b class="font-bold">
        Marketplace Shipping Weight
      </b>
      will affect "Adjustment Fixed" for Amazon using the formula
      <span class="text-red-500">
        7 + (MarketplaceShippingWeight X 2) = adjustmentFixed
      </span>
    </div> -->
  </div>
</template>
<script>
import {
  deleteMarketplaceItem,
  updateMarketplaceItem,
  syncToAmazon
} from "@/api/store/MarketplacesItemsService.js";

export default {
  name: "ProductMarketplacesManagerItem",
  data() {
    return {
      editing: false,
      editingProduct: {},
      originalProduct: {},
      syncing: false,
      showMenu: false
    };
  },
  mounted() {
    this.originalProduct = JSON.parse(JSON.stringify(this.item));
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    enableEditNkrCode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userCanEditMarketplacesItems() {
      return this.$store.getters["auth/userHasPermission"](
        "can_edit_marketplaces_items"
      );
    },
    priceAdjustmentShipment() {
      let item = this.item;
      if (this.editing) {
        item = this.editingProduct;
      }
      let base = 10;
      if (item.marketplaceShippingWeight >= 1) {
        base = 7;
      }
      return base + item.marketplaceShippingWeight * 2;
    },
    urlMarketplace() {
      if (this.item.marketplaceName === "amazon") {
        return `https://www.amazon.com/dp/${this.item.marketplaceItemId}`;
      } else {
        return `http://www.ebay.com/itm/${this.item.marketplaceItemId}`;
      }
    },
    syncStatusLabel() {
      const status = this.originalProduct.syncStatus;
      if (!status || status === "pending") return null;
      const labels = {
        submitted: this.$t("message.marketplaces.status_submitted"),
        accepted: this.$t("message.marketplaces.status_accepted"),
        error: this.$t("message.marketplaces.status_error"),
        disabled: this.$t("message.marketplaces.status_disabled")
      };
      return labels[status] || status;
    },
    syncStatusClass() {
      const map = {
        accepted: "bg-green-500",
        submitted: "bg-blue-500",
        error: "bg-red-500",
        disabled: "bg-gray-400"
      };
      return map[this.originalProduct.syncStatus] || "bg-gray-400";
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    runMenuAction(action) {
      this.closeMenu();
      action();
    },
    cancelEdition() {
      this.editingProduct = JSON.parse(JSON.stringify(this.originalProduct));
      this.editing = false;
    },
    initEdition() {
      this.editingProduct = JSON.parse(JSON.stringify(this.originalProduct));
      this.editing = true;
    },
    deleteProduct() {
      if (confirm("Do you want to delete this marketplace product?")) {
        deleteMarketplaceItem(this.item.id)
          .then(() => {
            this.$emit("deleted");
            this.$toast.open({
              message: `Item deleted`,
              type: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.$toast.open({
              message: `error deleting product`,
              type: "error",
              position: "top-right"
            });
          });
      }
    },
    updateAdjustment() {
      // if (this.editingProduct.marketplaceName !== "amazon") return;
      // this.editingProduct.priceAdjustmentFixed =
      //   7 + this.editingProduct.marketplaceShippingWeight * 2;
    },
    saveChanges() {
      updateMarketplaceItem(this.editingProduct).then(() => {
        this.originalProduct = JSON.parse(JSON.stringify(this.editingProduct));
        this.$emit("updated", this.editingProduct);
        this.editing = false;
      });
    },
    syncAmazon() {
      if (this.syncing) return;
      this.syncing = true;
      syncToAmazon(this.originalProduct.nkrCode)
        .then(res => {
          const result =
            res && res.results
              ? res.results.find(r => r.id === this.originalProduct.id)
              : null;
          if (result && result.ok === false) {
            this.originalProduct.syncStatus = "error";
            this.originalProduct.lastError = result.error;
            this.$toast.open({
              message: this.$t("message.marketplaces.sync_error"),
              type: "error",
              position: "top-right"
            });
          } else {
            this.originalProduct.syncStatus = result
              ? result.status === "ACCEPTED"
                ? "accepted"
                : "submitted"
              : "submitted";
            this.originalProduct.lastError = null;
            this.$toast.open({
              message: this.$t("message.marketplaces.sync_success"),
              type: "success",
              position: "top-right"
            });
          }
        })
        .catch(e => {
          this.$toast.open({
            message:
              (e && e.response && e.response.data) ||
              this.$t("message.marketplaces.sync_error"),
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.syncing = false;
        });
    }
  }
};
</script>
